import script from "./LocationSettings.vue?vue&type=script&lang=js"
export * from "./LocationSettings.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__